import React from "react";
import { SECTION_CONTAINER } from "../../utils/layout";
import ScrollReveal from "./Reveal";

function SectionHeader({
  eyebrow,
  title,
  subtitle,
  titleId,
  centered = true,
  dark = false,
  showAccent = false,
  reveal = false,
  className = "",
  containerClass = SECTION_CONTAINER,
}) {
  const headerAlign = centered ? " caf-section-header--center" : "";

  const header = (
    <header
      className={`${containerClass} caf-section-header${headerAlign} ${className}`}
    >
      {eyebrow && (
        <span className={`caf-eyebrow${dark ? " caf-eyebrow--dark" : ""}`}>
          {eyebrow}
        </span>
      )}
      {showAccent && (
        <div
          className={`caf-title-accent${centered ? " caf-title-accent--center" : " caf-title-accent--start"}`}
          aria-hidden="true"
        />
      )}
      {title && (
        <h2
          id={titleId}
          className={`caf-section-title${dark ? " caf-section-title--dark" : ""}`}
        >
          {title}
        </h2>
      )}
      {subtitle && (
        <p
          className={`caf-section-subtitle${dark ? " caf-section-subtitle--dark" : ""}`}
        >
          {subtitle}
        </p>
      )}
    </header>
  );

  if (!reveal) {
    return header;
  }

  return <ScrollReveal>{header}</ScrollReveal>;
}

export default SectionHeader;
